module.exports = __webpack_public_path__ + "static/media/popup_contact_us.d6e719a2.png";